/* eslint-disable react/prop-types */
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState, useCallback } from "react";
import { MultilineField, TextField } from 'style-guide';
import { useDispatch } from "react-redux";
import './shipmentDetailDialog/ShipmentDetailDialog.scss';
import { REQUEST_ACTIONS, sendRequest, getCustomerData, setOrderForSave } from "utils/Communicator";
import { snackbarToggle } from "reducers/snackbarSlicer";

const ilChatNameStyle = { color: 'blue' };
const nlChatNameStyle = { color: 'orange' };

const Chat = ({ order, orderList, setOrderList, loginUser }) => {
    const [chatList, setChatList] = useState([]);
    const [chatText, setChatText] = useState("");
    const dispatch = useDispatch();

    const failedCallback = useCallback(message => {
        dispatch(snackbarToggle({ type: 'error', message }))
    }, [dispatch]);

    useEffect(() => {
        if (order) {
            if (order.chatCustomer)
                setChatList(JSON.parse(order.chatCustomer));
            else
                setChatList([]);
            updateSeen();
        }
    }, [order])

    const getChatDate = (d) => {
        var date = new Date(d);
        var month = date.getMonth(date)+1;
        var day = date.getDate(date);
        var year = date.getFullYear(date) + "";

        var hr = date.getHours(date);
        var mn = date.getMinutes(date);
        if (hr < 10)
            hr = "0" + hr;
        if (mn < 10)
            mn = "0" + mn;
        if (day < 10)
            day = "0" + day;
        if (month < 10)
            month = "0" + month;
        return `${day}/${month}/${year.substr(2)} ${hr}:${mn}`;
    }

    const getInitiatorStyle = (ch) => {
        var type = ch['initiatorType']
        if (type == 5)
            return nlChatNameStyle;
        else
            return ilChatNameStyle;
    }

    const onHandlechangeChat = (value) => {
        setChatText(value);
    }

    const updateSeen = () => {
        if (order.chatCustomer) {
            var chat_list = JSON.parse(order.chatCustomer);
            var len = chat_list ? chat_list.length : 0;
            var changeMade = false;
            for (var j = 0; j < len; j++) {
                if (!chat_list[j]['NLStatus']) {
                    changeMade = true;
                    chat_list[j]['NLStatus'] = true;
                }
                if (chat_list[j]['notSeen']) {
                    if (chat_list[j]['notSeen'].includes(loginUser.id)) {
                        var index = chat_list[j]['notSeen'].indexOf(loginUser.id);
                        if (index > -1) {
                            changeMade = true;
                            chat_list[j]['notSeen'].splice(index, 1);
                        }
                    }
                }
            }
            if (changeMade) {
                order.chatCustomer = JSON.stringify(chat_list);
                setChatList(chat_list);
                var o1 = JSON.parse(JSON.stringify(order));
                if (o1.cstatus) {
                    o1.cstatus = JSON.stringify(o1.cstatus);
                }
                if (o1.astatus) {
                    o1.astatus = JSON.stringify(o1.astatus);
                }
                sendRequest('/api/order?fromStage=0&loginUserId=' + loginUser?.id + '&actionOn=ChatSeen', REQUEST_ACTIONS.POST, setOrderForSave(o1), {
                    loginUser: loginUser,
                    successCallback: response => {
                        if (orderList) {
                            var len = orderList.length;
                            var orders = [];
                            for (var i = 0; i < len; i++) {
                                var o = JSON.parse(JSON.stringify(orderList[i]));
                                if (o.id == o1.id) {
                                    o.chatCustomer = o1.chatCustomer;
                                }
                                orders.push(o);
                            }
                            setOrderList(orders);
                        }
                        setChatText("");
                    },
                    failedCallback,
                });
            }
        }
    };

    const onUpdateChat = (id, chatString, fromStage) => {
        var data = {
            value: chatString
        }
        sendRequest(`/api/order/updateCustChat/${id}?fromStage=${fromStage}&loginUserId=${loginUser?.id}&actionOn=ChatDialog`, REQUEST_ACTIONS.PUT, data, {
            loginUser: loginUser,
            successCallback: data => {
                setChatList(JSON.parse(data.chatCustomer));
                var orders = [];
                if (orderList) {
                    var len = orderList.length;
                    var orders = [];
                    for (var i = 0; i < len; i++) {
                        var order = JSON.parse(JSON.stringify(orderList[i]));
                        if (order.id == data.id) {
                            order.chatCustomer = data.chatCustomer;
                        }
                        orders.push(order);
                    }
                    setOrderList(orders);
                }
                setChatText("");
            },
            failedCallback,
        });
    };

    const onHandleSendChat = (statusChatButton) => {

        sendRequest(`/api/users?consigneeId=${loginUser.customer.id}`, REQUEST_ACTIONS.GET, null, {
            loginUser: loginUser,
            successCallback: userList => {
                var ids = [];
                for (var i = 0; i < userList.length; i++) {
                    if (userList[i].id != loginUser.id && userList[i].active != false)
                        ids.push(userList[i].id)
                }

                var exists = false;
                var date = new Date();
                var chat = {
                    'time': date.toUTCString(),
                    'notSeen': ids,
                    'text': chatText,
                    'initiator': loginUser.fullName,
                    'initiatorType': 5,
                    'location': 'All',
                    'ILStatus': false,
                    'NLStatus': true
                }
                let o1 = { ...order }

                var chat_list = [];
                if (order.chat) {
                    chat_list = JSON.parse(order.chat);
                }
                if (chat_list?.length) {
                    for (var j = 0; j < chat_list.length; j++) {
                        if (!chat_list[j]['NLStatus']) {
                            chat_list[j]['NLStatus'] = true;
                        }
                    }
                }
                if (!order.chat) {
                    chat_list[0] = chat;
                }
                else {
                    chat_list.push(chat);
                }

                var chatString = JSON.stringify(chat)

                onUpdateChat(order.id, chatString, 0);
            },
            failedCallback,
        });
        return;
    }
    return <Fragment>
        <div className="chatBoddyText" >
            <div style={{ height: 'auto', width: '100%' }}>
                {chatList?.map((ch, index) => (
                    <div key={index} style={{ width: '100%', padding: '5px' }}> <span style={{ color: 'grey' }}>{getChatDate(ch['time'])}</span> <span style={getInitiatorStyle(ch)}>{ch['initiator']}</span><span style={{ color: 'black' }}> : {ch['text']}</span></div>
                ))}
            </div>
            <div style={{ float: "left", clear: "both" }} id="bottomOfScreen"></div>
        </div>
        <Grid container item flexWrap="nowrap" justifyContent='space-evenly' style={{ fontSize: "14px" }}>
            <TextField
            className="chatBodyTextBox"
                sm={6} md={8} lg={8}  id="chatText" label="" variant="outlined" type="text" value={chatText}
                onChange={(event) => onHandlechangeChat(event.target.value)}
            />
            <Button class="chatSendButton" variant='contained' sx={{ mr: 2 }} onClick={(event) => onHandleSendChat(11)} >
                Chat
            </Button>
        </Grid>
    </Fragment>;
}

export default Chat;


